import './vendor.ts';

import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { TelerecourspnrAccountModule } from './account/account.module';
import { PaginationConfig } from './blocks/config/uib-pagination.config';
import { TelerecourspnrDepotRequeteModule } from './depot-requete/depot-requete.module';
import { TelerecourspnrFaqModule } from './faq/faq.module';
import { TelerecourspnrHomeModule } from './home/home.module';
import {
    ConditionGeneraleComponent,
    ErrorComponent,
    FooterComponent,
    JhiMainComponent,
    LayoutRoutingModule,
    MentionLegaleComponent,
    NavbarComponent,
    PageRibbonComponent,
    ProfileService,
} from './layouts';
import { MajSiteComponent } from './layouts/footer/maj-site/maj-site.component';
import { PlanSiteItemComponent } from './layouts/footer/plan-site/plan-site-item/plan-site-item.component';
import { PlanSiteComponent } from './layouts/footer/plan-site/plan-site.component';
import { TelerecourspnrRattachementModule } from './rattachement/rattachement.module';
import { TelerecourspnrRequeteModule } from './requete/requete.module';
import { TelerecourspnrSharedModule, UserRouteAccessService } from './shared';
import { AccountData } from './shared/components/identite-personne/data/account.data';
import { AccessibiliteComponent } from './layouts/footer/accessibilite/accessibilite.component';
import {TelerecourspnrUserClubModule} from './user-club/user-club.module';
import {PersonalDataComponent} from './layouts/footer/personal-data/personal-data.component';
import {InactivityService} from './modals/inactivity-modal/inactivity.service';
import {InactivityModalComponent} from './modals/inactivity-modal/inactivity-modal.component';
import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthExpiredInterceptor } from './blocks/interceptor/auth-expired.interceptor';
import { DraftHeaderInterceptor } from './blocks/interceptor/draft-header.interceptor';
import {Ng2Webstorage} from 'ngx-webstorage';
import localeFr from '@angular/common/locales/fr';
import {registerLocaleData} from '@angular/common';

registerLocaleData(localeFr, 'fr');

@NgModule({
    imports: [
        BrowserModule,
        LayoutRoutingModule,
        Ng2Webstorage.forRoot({ prefix: 'jhi', separator: '-' }),
        TelerecourspnrSharedModule,
        TelerecourspnrHomeModule,
        TelerecourspnrAccountModule,
        TelerecourspnrRequeteModule,
        TelerecourspnrFaqModule,
        TelerecourspnrRattachementModule,
        TelerecourspnrDepotRequeteModule,
        TelerecourspnrUserClubModule
    ],
    declarations: [
        JhiMainComponent,
        NavbarComponent,
        ErrorComponent,
        PageRibbonComponent,
        FooterComponent,
        MentionLegaleComponent,
        ConditionGeneraleComponent,
        PlanSiteComponent,
        PlanSiteItemComponent,
        MajSiteComponent,
        AccessibiliteComponent,
        PersonalDataComponent,
        InactivityModalComponent
    ],
    providers: [
        ProfileService,
        { provide: LOCALE_ID, useValue: 'fr' },
        { provide: HTTP_INTERCEPTORS, useClass: AuthExpiredInterceptor, multi: true},
        { provide: HTTP_INTERCEPTORS, useClass: DraftHeaderInterceptor, multi: true},
        PaginationConfig,
        UserRouteAccessService,
        AccountData,
        NgbActiveModal,
        InactivityService,
        DatePipe
    ],
    bootstrap: [JhiMainComponent],
})
export class TelerecourspnrAppModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/app.module.ts